export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/TJ-f178ef8b1f5ba4925e9525250c621ba5.png";